import { RgCreate, DefaultPlot, getRgObjectsOfType, RG_TYPE, GetAllMuscles } from "@project-rouge/rg-core";
import { Vector3toV3, intersectPolygons, MuscleToVector } from "@project-rouge/rg-three";
import { Vector3, MathUtils } from "three";
import { pipeAddMuscles } from "./index90.js";
import { pipeTailor } from "./index109.js";
import { nelderMead } from "./index227.js";
import { getRatiosFromData } from "./index228.js";
import { recursiveSubdivisionFromData } from "./index229.js";
const optimisePlots = (zone, aggProps, divisionData) => {
  const tailorDataOut = { mainThreads: [], mainFrozenThreads: [] };
  const rvData = aggProps.dataset.rvData;
  clearZone(zone);
  const tempAggProps = {
    ...aggProps,
    // disable/freeze all other zones for this optimisation
    zones: Object.fromEntries(
      Object.entries(aggProps.zones).filter((z) => z[0] === zone.uuid)
    )
  };
  for (let i = 0; i < zone.data.polygons.length; i++) {
    let f = function(x) {
      clearZone(zone);
      const xMod = x.map((v) => MathUtils.clamp(v, 0, 1));
      let newPlotPolys2 = recursiveSubdivisionFromData(data, xMod.slice());
      newPlotPolys2 = retrimPolys(zone, i, newPlotPolys2);
      createPlots(newPlotPolys2, zone, i, rvData);
      pipeTailor([zone, { aggProps: tempAggProps }]);
      pipeAddMuscles([zone, { aggProps: tempAggProps }]);
      return -score(zone);
    };
    const data = divisionData[i];
    const ratiosList = getRatiosFromData(data);
    const x0 = ratiosList.slice();
    const resultRatios = nelderMead(f, x0, { maxIterations: 10 }).x.point;
    clearZone(zone);
    let newPlotPolys = recursiveSubdivisionFromData(data, resultRatios);
    newPlotPolys = retrimPolys(zone, i, newPlotPolys);
    createPlots(newPlotPolys, zone, i, rvData);
    const [, tailorData] = pipeTailor([zone, { aggProps: tempAggProps }]);
    tailorDataOut.mainThreads.push(...tailorData.mainThreads);
    tailorDataOut.mainFrozenThreads.push(...tailorData.mainFrozenThreads);
  }
  return { parent: zone, tailorDataOut };
};
function retrimPolys(zone, i, plotPolys) {
  let newPlotPolys = [];
  const originalZonePolygon = zone.data.polygons[i].map(Vector3toV3);
  const plotPolysCopy = plotPolys.map((poly) => poly.map(Vector3toV3));
  newPlotPolys = plotPolysCopy.flatMap((c) => intersectPolygons(originalZonePolygon, [c]));
  return newPlotPolys;
}
function createPlots(newPlotPolys, zone, i, rvData) {
  for (const polygon of newPlotPolys) {
    const plot = RgCreate({
      ...DefaultPlot,
      parent: zone,
      data: {
        polygon,
        zonePolyIndex: i
      }
    }, rvData);
    zone.children.push(plot);
  }
}
const mVector = new Vector3();
function score(obj) {
  const buildings = getRgObjectsOfType(obj, RG_TYPE.Building);
  let totalLength = 0;
  for (const b of buildings) {
    const muscles = GetAllMuscles(b.data.anatomy);
    totalLength += muscles.reduce((sum, m) => sum + MuscleToVector(m, mVector).length(), 0);
  }
  return totalLength;
}
function clearZone(zone) {
  zone.children.length = 0;
}
export {
  optimisePlots
};
//# sourceMappingURL=index184.js.map
